module.exports = __webpack_public_path__ + "img/camp_shirt_gk2.6b4421b5.svg";